module.exports = __webpack_public_path__ + "public/img/total1.be7d3c0f.png";